// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('support.supportcases.mergeproducts', {
        url:'/mergeproducts',
        views: {
            'supportView@support': {
            templateUrl: 'main/support/supportcases/mergeproducts/mergeproducts.tpl.html',
            controller: 'SupportCaseMergeProductController as vm'
        }},
        resolve: {
        }
    });
}

// @ngInject
function SupportCaseMergeProductController($state, $scope, SupportApiService, loadSpinnerService, ToasterService, confirmationDialogService, $translate) {
    var vm = this;

    //Properties
    vm.selectedToProduct = {};
    vm.selectedFromProduct1 = {};
    vm.selectedFromProduct2 = {};
    vm.selectedFromProduct3 = {};

    //Methods
    vm.recieveToProduct = recieveToProduct;
    vm.recieveFromProduct1 = recieveFromProduct1;
    vm.recieveFromProduct2 = recieveFromProduct2;
    vm.recieveFromProduct3 = recieveFromProduct3;
    vm.removeToProduct = removeToProduct;
    vm.removeFromProduct1 = removeFromProduct1;
    vm.removeFromProduct2 = removeFromProduct2;
    vm.removeFromProduct3 = removeFromProduct3;
    vm.isAllowedToMerge = isAllowedToMerge;
    vm.mergeProducts = mergeProducts;

    activate();

    function activate() {
    }

    function mergeProducts() {
        var toProduct = vm.selectedToProduct.id;
        var fromProduct1 = vm.selectedFromProduct1 ? vm.selectedFromProduct1.id : null;
        var fromProduct2 = vm.selectedFromProduct2 && vm.selectedFromProduct2.id ? vm.selectedFromProduct2.id : null;
        var fromProduct3 = vm.selectedFromProduct3 && vm.selectedFromProduct3.id ? vm.selectedFromProduct3.id : null;

        var message = '<div>' +
            'Är du säker på att du vill slå samman följande produkter? Handlingen går inte att ångra.' + //$translate.instant("support.confirmMergeData") +
            '<table style="width:100%; margin: 5px 10px;">';
        message += '<thead><tr><th>Produktnummer</td><th>Lev. produktnummer</td><th>Produktnamn</td></tr></thead>';
        message += '<tbody>';
        if (fromProduct1 !== null) { message += '<tr><td>' + vm.selectedFromProduct1.articleNumber + '</td><td>' + vm.selectedFromProduct1.alternativeArticleNumber + '</td><td>' + vm.selectedFromProduct1.articleName + '</td></tr>'; }
        if (fromProduct2 !== null) { message += '<tr><td>' + vm.selectedFromProduct2.articleNumber + '</td><td>' + vm.selectedFromProduct2.alternativeArticleNumber + '</td><td>' + vm.selectedFromProduct2.articleName + '</td></tr>'; }
        if (fromProduct3 !== null) { message += '<tr><td>' + vm.selectedFromProduct3.articleNumber + '</td><td>' + vm.selectedFromProduct3.alternativeArticleNumber + '</td><td>' + vm.selectedFromProduct3.articleName + '</td></tr>'; }
        message += '<tr><td colspan="3" style="text-align:center; padding: 10px 10px;"> &darr; &darr; &darr; </td></tr>';
        message += '<tr><td>' + vm.selectedToProduct.articleNumber + '</td><td>' + vm.selectedToProduct.alternativeArticleNumber + '</td><td>' + vm.selectedToProduct.articleName + '</td></tr>';
        message += '</tbody>';
        message += '</table>';
        message += '</div>';

        confirmationDialogService.showDialog(message).then(function (result) {
            if (result === true) {
                loadSpinnerService.start("mainSpinner");
                var request = {
                    toProductId: toProduct,
                    fromProduct1Id: fromProduct1,
                    fromProduct2Id: fromProduct2,
                    fromProduct3Id: fromProduct3
                };
                SupportApiService.mergeProducts(request).then(function(response) {
                    $scope.$broadcast('clearArticleEvent');
                    vm.selectedToProduct = {};
                    vm.selectedFromProduct1 = {};
                    vm.selectedFromProduct2 = {};
                    vm.selectedFromProduct3 = {};
                    ToasterService.showSuccess('Produkterna ihopslagna', //$translate.instant('support.productsMerged')
                        $translate.instant('support.supportCase'));
                }, function(error) {
                    ToasterService.showError(error.message, $translate.instant('common.error'));
                }).finally(function() {
                    loadSpinnerService.stop("mainSpinner");
                });
            }
        });
    }

    function recieveToProduct(product) {
        vm.selectedToProduct = product;
    }
    function recieveFromProduct1(product) {
        vm.selectedFromProduct1 = product;
    }
    function recieveFromProduct2(product) {
        vm.selectedFromProduct2 = product;
    }
    function recieveFromProduct3(product) {
        vm.selectedFromProduct3 = product;
    }
    function removeToProduct() {
        vm.selectedToProduct = {};
    }
    function removeFromProduct1() {
        vm.selectedFromProduct1 = {};
    }
    function removeFromProduct2() {
        vm.selectedFromProduct2 = {};
    }
    function removeFromProduct3() {
        vm.selectedFromProduct3 = {};
    }

    function isAllowedToMerge() {
        var hasToProduct = vm.selectedToProduct && vm.selectedToProduct.id > 0;
        var hasFromProduct1 = vm.selectedFromProduct1 && vm.selectedFromProduct1.id > 0;
        var hasFromProduct2 = vm.selectedFromProduct2 && vm.selectedFromProduct2.id > 0;
        var hasFromProduct3 = vm.selectedFromProduct3 && vm.selectedFromProduct3.id > 0;

        return hasToProduct && (hasFromProduct1 || (hasFromProduct1 || hasFromProduct2 || hasFromProduct3));
    }
}

angular
    .module('supportcases.mergeproducts', ['support.api'])
    .config(stateConfig)
    .controller('SupportCaseMergeProductController', SupportCaseMergeProductController);
